<template>
  <v-row v-if="visible" class="mb-1">
    <v-col cols="12" sm="4">
      <v-card class="pa-4 fill-height" variant="outlined">
        <div class="text-caption text-grey-darken-1">
          {{ $t("acceptance.deadlines.depollution") }}
        </div>
        <div class="text-h6 font-weight-bold">
          {{ depollution || "—" }}
        </div>
        <div class="text-caption text-grey-darken-1">
          {{ ruleText("depollution") }}
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" sm="4">
      <v-card class="pa-4 fill-height" variant="outlined">
        <div class="text-caption text-grey-darken-1">
          {{ $t("acceptance.deadlines.deregistration") }}
        </div>
        <div class="text-h6 font-weight-bold">
          {{ deregistration || "—" }}
        </div>
        <div class="text-caption text-grey-darken-1">
          {{ ruleText("deregistrationRequest") }}
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" sm="4">
      <v-card class="pa-4 fill-height" variant="outlined">
        <div class="text-caption text-grey-darken-1">
          {{ $t("acceptance.deadlines.confirmed_by") }}
        </div>
        <div class="text-body-1 font-weight-medium">{{ confirmedBy }}</div>
        <div class="text-caption text-grey-darken-1">
          {{ confirmedAt }}
        </div>
        <div class="text-caption text-grey-darken-1">
          {{
            $t("acceptance.deadlines.rules_and_warnings", {
              version: dossier.rulesVersionAtConfirm || "—",
              count: (dossier.warningsAtConfirm || []).length,
            })
          }}
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import {
  dueDateText,
  formatCivilDate,
} from "@/components/Acceptance/deadlines.mjs";

export default {
  name: "AcceptanceDeadlineCards",
  props: {
    // The dossier as the API returns it (status, deadlines, confirmedBy, confirmedAt, ...).
    dossier: { type: Object, required: true },
  },
  computed: {
    visible() {
      return this.dossier.status === "confirmed";
    },
    depollution() {
      return dueDateText(this.dossier, "depollution");
    },
    deregistration() {
      return dueDateText(this.dossier, "deregistrationRequest");
    },
    confirmedBy() {
      const actor = this.dossier.confirmedBy || {};
      const name = actor.name || "—";
      return actor.role ? `${name} (${actor.role})` : name;
    },
    confirmedAt() {
      return this.dossier.confirmedAt
        ? moment(this.dossier.confirmedAt).format("DD/MM/YYYY HH:mm")
        : "";
    },
  },
  methods: {
    // "Dall'arrivo del 01/04/2026". The deadline rule version is stored with the dossier but not
    // shown.
    ruleText(kind) {
      const deadline = (this.dossier.deadlines || {})[kind];
      if (!deadline) return "";
      return this.$t("acceptance.deadlines.rule_from_arrival", {
        arrival: formatCivilDate(deadline.fromArrivalDate),
      });
    },
  },
};
</script>
